module.exports = __webpack_public_path__ + "static/media/bg.26fc2804.png";